import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_RENOLOG / _RENOLOG_ADMIN=true in .env.local for the
// local API.
export const RENOLOG_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_RENOLOG
);
export const RENOLOG_ADMIN_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_RENOLOG_ADMIN
);
